import getPlainTextFromHTML from "shared/helpers/utils/getPlainTextFromHTML";

interface MetaElementsProps {
    title?: string;
    imageUrl?: string | null;
    description?: string[];
    url?: string;
}

const getMetaElements = ({ title, imageUrl, description, url }: MetaElementsProps) => {
    const descriptionElements: any = []
    //todo: понять, почему тут массив, а не строка
    description?.forEach((item) => {
        if (item?.length) {
            const plainText = getPlainTextFromHTML(item);
            descriptionElements.push({
                property: "og:description",
                content: plainText,
            });
            descriptionElements.push({
                property: "twitter:description",
                content: plainText,
            });
            descriptionElements.push({
                itemProp: "description",
                content: plainText,
            });
        }
    });

    return [
        ...descriptionElements,
        {
            itemProp: "name",
            content: title,
        },
        {
            name: "title",
            content: title,
        },
        {
            property: "og:title",
            content: title,
        },
        {
            property: "twitter:title",
            content: title,
        },
        ...(imageUrl ? [{
            itemProp: "image",
            content: imageUrl,
        },
        {
            property: "og:image",
            content: imageUrl,
        },
        {
            property: "twitter:image",
            content: imageUrl,
        },
        {
            property: "vk:image",
            content: imageUrl,
        },
        {
            property: "twitter:card",
            content: "summary_large_image",
        }] : []),
        ...(url ? [{
            property: "og:url",
            content: url,
        }, {
            property: "og:type",
            content: "website",
        }] : [])]
}

export default getMetaElements;import getPlainTextFromHTML from "shared/helpers/utils/getPlainTextFromHTML";

interface MetaElementsProps {
    title?: string;
    imageUrl?: string | null;
    description?: string[];
    url?: string;
}

const getMetaElements = ({ title, imageUrl, description, url }: MetaElementsProps) => {
    const descriptionElements: any = []
    //todo: понять, почему тут массив, а не строка
    description?.forEach((item) => {
        if (item?.length) {
            const plainText = getPlainTextFromHTML(item);
            descriptionElements.push({
                property: "og:description",
                content: plainText,
            });
            descriptionElements.push({
                property: "twitter:description",
                content: plainText,
            });
            descriptionElements.push({
                itemProp: "description",
                content: plainText,
            });
        }
    });

    return [
        ...descriptionElements,
        {
            itemProp: "name",
            content: title,
        },
        {
            name: "title",
            content: title,
        },
        {
            property: "og:title",
            content: title,
        },
        {
            property: "twitter:title",
            content: title,
        },
        ...(imageUrl ? [{
            itemProp: "image",
            content: imageUrl,
        },
        {
            property: "og:image",
            content: imageUrl,
        },
        {
            property: "twitter:image",
            content: imageUrl,
        },
        {
            property: "vk:image",
            content: imageUrl,
        },
        {
            property: "twitter:card",
            content: "summary_large_image",
        }] : []),
        ...(url ? [{
            property: "og:url",
            content: url,
        }, {
            property: "og:type",
            content: "website",
        }] : [])]
}

export default getMetaElements;